"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFuture = exports.requiredDate = exports.isNotFuture = exports.validYear = exports.validMonth = exports.validDay = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _validators = require("@sword-health/vuelidate/lib/validators");

var _utils = require("./utils.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function isEmptyDate(date) {
  return !date || date === '--';
}

;

var validDay = function validDay() {
  return _validators.helpers.withParams({
    type: 'validDay',
    min: 1,
    max: 31
  }, function (date) {
    if (isEmptyDate(date)) {
      return true;
    }

    var _splitDate = (0, _utils.splitDate)(date),
        day = _splitDate.day,
        year = _splitDate.year,
        month = _splitDate.month;

    if (!Number(day)) {
      return false;
    }

    var dateRef = (0, _dayjs["default"])().set("month", month - 1);

    if (year && year.length === 4) {
      dateRef = dateRef.set("year", year);
    }

    var lastDayInMonth = dateRef.endOf('month').$D;
    return lastDayInMonth >= day;
  });
};

exports.validDay = validDay;

var validMonth = function validMonth(date) {
  if (isEmptyDate(date)) {
    return true;
  }

  var _splitDate2 = (0, _utils.splitDate)(date),
      month = _splitDate2.month;

  return !!Number(month);
};

exports.validMonth = validMonth;

var validYear = function validYear(min, max) {
  return _validators.helpers.withParams({
    type: 'validYear',
    min: min,
    max: max
  }, function (date) {
    if (isEmptyDate(date)) {
      return true;
    }

    var year = (0, _utils.splitDate)(date).year;

    if (!date || !Number(year) || year.length < 4) {
      return false;
    }

    if (!max) {
      return !!year && min <= year;
    }

    return !!year && min <= year && year <= max;
  });
};

exports.validYear = validYear;

var isNotFuture = function isNotFuture(date) {
  if (isEmptyDate(date)) {
    return true;
  }

  return date ? !(0, _dayjs["default"])(date).isAfter(new Date()) : false;
};

exports.isNotFuture = isNotFuture;

var isFuture = function isFuture(date) {
  if (isEmptyDate(date)) {
    return true;
  }

  return !isNotFuture(date);
};

exports.isFuture = isFuture;

var requiredDate = function requiredDate(date) {
  var dateSplit = (0, _utils.splitDate)(date);
  return dateSplit.day && dateSplit.month && dateSplit.year;
};

exports.requiredDate = requiredDate;